import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgClipboardGraph = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M18.875 12.625V6.375C18.875 6.04348 18.7433 5.72554 18.5089 5.49112C18.2745 5.2567 17.9565 5.125 17.625 5.125H15.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.125 17.625V20.125C5.125 20.4565 5.2567 20.7745 5.49112 21.0089C5.72554 21.2433 6.04348 21.375 6.375 21.375H17.625C17.9565 21.375 18.2745 21.2433 18.5089 21.0089C18.7433 20.7745 18.875 20.4565 18.875 20.125V17.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.875 5.125H6.375C6.04348 5.125 5.72554 5.2567 5.49112 5.49112C5.2567 5.72554 5.125 6.04348 5.125 6.375V12.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 15.125H7.43167C7.48974 15.125 7.54667 15.1089 7.59612 15.0784C7.64556 15.048 7.68556 15.0044 7.71167 14.9525L9.175 12.025C9.20226 11.9703 9.24496 11.9248 9.29781 11.8941C9.35067 11.8634 9.41136 11.8489 9.47237 11.8524C9.53339 11.8559 9.59205 11.8771 9.6411 11.9136C9.69014 11.95 9.72743 12.0001 9.74833 12.0575L11.735 17.5225C11.7556 17.5823 11.7938 17.6345 11.8447 17.6721C11.8955 17.7097 11.9566 17.731 12.0198 17.7331C12.083 17.7353 12.1454 17.7182 12.1987 17.6842C12.252 17.6502 12.2937 17.6008 12.3183 17.5425L14.235 13.23C14.2591 13.1759 14.2981 13.1298 14.3474 13.097C14.3967 13.0642 14.4543 13.0461 14.5135 13.0448C14.5727 13.0434 14.6311 13.059 14.6818 13.0896C14.7325 13.1202 14.7735 13.1645 14.8 13.2175L15.6667 14.9525C15.6928 15.0044 15.7328 15.048 15.7822 15.0784C15.8317 15.1089 15.8886 15.125 15.9467 15.125H21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.8375 3.875C13.7116 3.49342 13.4632 3.16407 13.131 2.93806C12.7987 2.71205 12.4012 2.602 12 2.625C11.5995 2.60294 11.2029 2.71343 10.8715 2.93938C10.5402 3.16532 10.2924 3.49414 10.1667 3.875H9.5C9.33424 3.875 9.17527 3.94085 9.05806 4.05806C8.94085 4.17527 8.875 4.33424 8.875 4.5V7C8.875 7.16576 8.94085 7.32473 9.05806 7.44194C9.17527 7.55915 9.33424 7.625 9.5 7.625H14.5C14.6658 7.625 14.8247 7.55915 14.9419 7.44194C15.0592 7.32473 15.125 7.16576 15.125 7V4.5C15.125 4.33424 15.0592 4.17527 14.9419 4.05806C14.8247 3.94085 14.6658 3.875 14.5 3.875H13.8375Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgClipboardGraph.displayName = 'SvgClipboardGraph';
export default SvgClipboardGraph;
